"use client"

import { Box, colors } from "@mui/material"
import { TOP_BAR_HEIGHT } from "@v2/components/header/constants"
import { useAppSelector } from "@v2/lib/redux/hooks"
import { Fragment, ReactNode, useEffect } from "react"
import { plpHeaderHeight, PLP_STICKY_TOP } from "./plpStickyMetrics"
import scrollToPlpHeader, { consumePlpHeaderScrollRequest } from "./scrollToPlpHeader"

export default function PlpHeaderHolder({ children, stacked = false }: {
    children: ReactNode,
    stacked?: boolean,
}) {
    const height = plpHeaderHeight(stacked)
    const headerIsShow = useAppSelector(s => s.general.headerIsShow)
    const topWhenShown = PLP_STICKY_TOP

    // The list this page renders has just committed, so a control that asked to be
    // carried down to it - or to the category strip above it - is answered here.
    useEffect(() => {
        const scrollTarget = consumePlpHeaderScrollRequest();
        if (!scrollTarget) return;
        return scrollToPlpHeader(scrollTarget);
    }, [])

    return (
        <Fragment>
            <Box id="plp_header_holder" sx={{ scrollMarginTop: topWhenShown }}></Box>
            <Box component="section" id="plp_header" sx={{
                height,

                position: 'sticky',
                top: TOP_BAR_HEIGHT,
                zIndex: 90,
                transition: '0.5s cubic-bezier(0.22,0.61,0.36,1)',

                ...(headerIsShow ? {
                    transitionDelay: '100ms',
                    top: topWhenShown,
                } : {}),
            }} >
                <Box sx={{
                    boxSizing: 'content-box',
                    height: 1,
                }}>
                    <Box sx={{
                        px: {
                            xs: 2,
                            lg2: 0
                        },
                        borderBottom: '1px solid',
                        borderColor: colors.grey[200],
                        bgcolor: '#fff',

                        height,
                    }}>
                        <Box sx={{
                            maxWidth: 1400,
                            margin: 'auto',
                            height: 1
                        }}>
                            {children}
                        </Box>
                    </Box>
                </Box>
            </Box>
        </Fragment>
    )
}
